import { UserDetails } from 'app/modules/user-management/user-details/components/UserDetails/UserDetails';

export const UserDetailsPage = (): JSX.Element => <UserDetails />;
